import '../styles.css'
import { Horizontal, Texto, useThemeContext } from '@gravitate-js/excalibrr'
import type { MapStyle } from '../types'

type MapStyleToggleProps = {
  currentStyle: MapStyle
  handleMapStyle: (key: MapStyle) => void
}

export function MapStyleToggle({ currentStyle, handleMapStyle }: MapStyleToggleProps) {
  const { currentTheme } = useThemeContext()

  return (
    <Horizontal style={{ position: 'absolute', bottom: 10, right: 50, zIndex: 1000 }} gap={8}>
      <button
        type='button'
        className={`map-style-preview default-${currentTheme} ${currentStyle === 'default' ? 'active' : ''}`}
        onClick={() => {
          handleMapStyle('default')
        }}
      >
        <Texto category='label' weight={'bold'}>
          Default
        </Texto>
      </button>
      <button
        type='button'
        className={`map-style-preview satellite ${currentStyle === 'satellite' ? 'active' : ''}`}
        onClick={() => {
          handleMapStyle('satellite')
        }}
      >
        <Texto category='label' weight={'bold'}>
          Satellite
        </Texto>
      </button>
    </Horizontal>
  )
}
